<template>
    <form class="col-12 text-right form-inline">
        <div class="col-6">
          <label for="aop">Área Operacional</label>
          <b-form-select
              id="aop"
              :options="aopOptions"
              value="Todas"
              class="form-control"
              @change="changeAopFilter"
          >
          </b-form-select>
          </div>
          <div class="col-6">
          <label for="regiaoMB">Região MB</label>
          <b-form-select
              id="regiaoMB"
              :options="regionOptions"
              value="Todas"
              class="form-control"
              @change="changeRegiaoFilter"
          >
          </b-form-select>
        </div>
    </form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import EventBus from '../../../eventBus';

export default {
  data: () => ({
    aop: [],
    region: [],
    aopOptions: [],
    regionOptions: [],
  }),
  computed: {
    ...mapState('stockFilter', ['aops', 'regions']),
  },
  methods: {
    ...mapActions('stockFilter', ['getAop', 'getRegion']),

    async loadData() {
      await this.getAop({});
      this.aop = this.aops;
      this.aopOptions = this.aop.map(aop => aop.aop);
      this.aopOptions.unshift('Todas');
      await this.getRegion({});
      this.region = this.regions;
      this.regionOptions = this.region.map(region => region.regiao_mb);
      this.regionOptions.unshift('Todas');
    },
    changeAopFilter(newValue) {
      EventBus.$emit('change-aop', newValue);
    },
    changeRegiaoFilter(newValue) {
      EventBus.$emit('change-region', newValue);
    },
  },
  async mounted() {
    await this.loadData();
  },
};
</script>

<style scoped>
.f-right {
  float: right;
}
select {
  width: 100% !important;
  height: 35px !important;
  padding: 0px !important;
}
.form-inline label {
    font-size: 13px;
      justify-content: left;
}
</style>
